const createSlug = require('./createSlug')
const { charsOkInUrl } = require('../../../src/constants/slugs')

module.exports = function slugifyUrl (url) {
    return createSlug(url, { additionalyAllowed: charsOkInUrl })
}